import { useSuspenseQuery } from '@tanstack/react-query';
import type { Item } from '@outdoria/types';
import { fetcher } from '../utils';
import { ADMIN_ITEMS_ALL } from '../queryKeys';

export const useAdminGetAllItems = () => {
  const queryFn = async (): Promise<Item[]> => {
    const res = await fetcher(`/v2/admin/items`);
    return res.json();
  };

  const {
    data = [],
    isLoading,
    isFetched,
    isError,
  } = useSuspenseQuery<Item[], unknown, Item[], string[]>({
    queryKey: ADMIN_ITEMS_ALL,
    queryFn: queryFn,
  });

  return { data, isLoading, isFetched, isError };
};
